import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'

export class ArchiveQuizVersionUseCase {
  private quizRepository: IQuizRepository

  constructor(quizRepository: IQuizRepository) {
    this.quizRepository = quizRepository
  }

  async execute(quizId: number, versionId: number): Promise<Quiz> {
    return await this.quizRepository.archiveQuizVersion(quizId, versionId)
  }
}
